import { render, staticRenderFns } from "./iluminacao.vue?vue&type=template&id=40dc2d1e"
import script from "./iluminacao.vue?vue&type=script&lang=js"
export * from "./iluminacao.vue?vue&type=script&lang=js"
import style0 from "./iluminacao.vue?vue&type=style&index=0&id=40dc2d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports